// GetQuote.js

import React, { useState, useCallback } from 'react';

import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Products from '../../containers/Products';
import GetBasket from '../GetBasket/GetBasket';

const GetQuote = () => {
  const { id } = useParams();
  // The promo flow bumps this counter to request a basket refresh.
  const triggerGetBasket = useSelector(state => state.promoCode?.triggerGetBasket ?? 0);
  const [getBasketLoading, setGetBasketLoading] = useState(true);

  // Memoised so its identity is stable across renders — otherwise GetBasket's
  // effect (which lists onLoadingChange as a dependency) would re-run and refetch.
  const handleGetBasketLoading = useCallback((isLoading) => {
    setGetBasketLoading(isLoading);
  }, []);

  return (
    <div>
      {/* Single basket loader: handles the initial load and promo-code refreshes (trigger). */}
      <GetBasket id={id} onLoadingChange={handleGetBasketLoading} trigger={triggerGetBasket} />

      {/* Render the QuoteProducts component only when GetBasket is done loading */}
      {!getBasketLoading && <Products />}
    </div>
  );
};

export default GetQuote;
